<template>
	<div class="form">
		<div class="form-item">
			<div class="form-item-main">
				<div class="label">手机号：</div>
				<van-field center clearable v-model="formdata.phone" placeholder="请输入手机号" />
			</div>
			<div class="error" v-if="errors.phone">{{ errors.phone }}</div>
		</div>
		<div class="form-item">
			<div class="form-item-main">
				<div class="label">密码：</div>
				<van-field type="password" center clearable v-model="formdata.newpass" placeholder="请输入新密码(6-16位数字组合)" />
			</div>
			<div class="error" v-if="errors.newpass">{{ errors.newpass }}</div>
		</div>
		<div class="wangji" @click="wangji">忘记密码？</div>
	</div>
</template>

<script>
export default {
	name: 'index',
	props: ["login"],
	data(){
		return {
			formdata:{
				phone:"",
				newpass:"",
			},
			errors: {
				phone: '',
				newpass: '',
			},
		}
	},

	created(){

	},
	mounted() {

	},

	computed: {

	},
	watch: {

	},
	methods: {
		wangji(){
			this.$emit('wangji', '');
		},
		validateForm() {
			// 重置错误信息
			this.errors = {
				phone: '',
				password: '',
			};
		
			let valid = true;
		
			// 手机号校验：11位数字，符合中国手机号格式
			const phoneRegex = /^1[3-9]\d{9}$/;
			if (!this.formdata.phone) {
				this.errors.phone = '手机号不能为空';
				valid = false;
			} else if (!phoneRegex.test(this.formdata.phone)) {
				this.errors.phone = '手机号格式不正确';
				valid = false;
			}
		
			// 密码校验：6-16位字符
			if (!this.formdata.newpass) {
				this.errors.newpass = '密码不能为空';
				valid = false;
			} else if (this.formdata.newpass.length < 6 || this.formdata.newpass.length > 16) {
				this.errors.newpass = '密码必须是6到16位字符';
				valid = false;
			}
		
			if (valid) {
				return true
			} else {
				return false
			}
		},
	}
}
</script>

<style lang="scss" scoped>
	.form{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: 100%;
		.form-item{
			margin-bottom: 1rem;
			.form-item-main{
				display: flex;
				align-items: center;
			}
			.label{
				width: 8rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1.2rem;
				color: #282D30;
				line-height: 1.41rem;
				text-align: right;
				margin-right: 1.5rem;
			}
			.van-cell{
				width: 28.6rem;
				height: 3.1rem;
				border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
				border: 0.05rem solid #E0E0E0;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1.2rem;
				line-height: 2.1rem;
			}
			.van-button{
				width: 6.15rem;
				height: 1.85rem;
				background: rgb(100, 45, 113);
				border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1rem;
				color: #FFFFFF;
				line-height: 1.85rem;
				text-align: center;
			}
			::v-deep .van-field__button{
				display: flex;
			}
		}
		.wangji{
			width: 37rem;
			height: 1.35rem;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 400;
			font-size: 1rem;
			color: #666666;
			line-height: 1.17rem;
			text-align: right;
			font-style: normal;
			text-decoration-line: underline;
			text-transform: none;
			margin-top: 0.75rem;
			cursor: pointer;
		}
	}
	.error {
	  color: red;
	  font-size: 1.2rem;
		width: 18.5rem;
		margin-left: 9.5rem;
		margin-top: 0.5rem;
	}
</style>